<template>
    <div class="mt-4">
        <div v-if="!images.length" class="d-flex flex-column justify-center no-files">
            <v-icon size="100"> mdi-image-search-outline </v-icon>
            <div class="text-center overline font-weight-light">
                No hay imágenes para mostrar
            </div>
        </div>
        <div v-for="image, index in images" :key="image.id">
            <h2 v-if="hasAdminPermission" class="font-weight-light mt-6 mx-12">{{ image.account ? image.account.nombre_completo : '' }}</h2>
            <v-divider v-if="hasAdminPermission && index > 1" class="mx-12"></v-divider>
            <v-row class="d-flex justify-space-around mt-6">
                <v-col cols="12" md="4" class="d-flex flex-column justify-center" flat>
                    <div class="d-flex justify-center" style="height: 250px">
                        <img v-if="image.signature" class="image" :src="image.signature" :width="$vuetify.breakpoint.smAndUp  ? 400 : '100%'">
                        <div v-else class="d-flex flex-column justify-center no-files">
                            <v-icon size="100"> mdi-image-search-outline </v-icon>
                            <div class="text-center overline font-weight-light">
                                No hay imágenes para mostrar
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-space-around mt-5" >
                        <h3 class="font-weight-light d-flex justify-center">Firma</h3>
                        <v-tooltip bottom  v-if="!$vuetify.breakpoint.smAndDown">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon 
                                    @click="isOpenCanvaSign = true" 
                                    color="yellow darken-4"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-signature-freehand
                                </v-icon>
                            </template>
                            <span>Crear Firma</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon 
                                    @click="openFileUpload('mdi-signature-text', 'signature', 'Adjuntar Firma', image.account ? image.account.id : null)" 
                                    color="green"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-image-plus-outline
                                </v-icon>
                            </template>
                            <span>Adjuntar Firma</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    :disabled="!image.signature" 
                                    @click="deleteImage(image.id, 'signature')" 
                                    color="red"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>Borrar</span>
                        </v-tooltip>
                    </div>
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column justify-center" flat>
                    <div class="d-flex justify-center" style="height: 250px">
                        <img v-if="image.dni_front" class="image" :src="image.dni_front" :width="$vuetify.breakpoint.smAndUp  ? 400 : '100%'">
                        <div v-else class="d-flex flex-column justify-center no-files">
                            <v-icon size="100"> mdi-image-search-outline </v-icon>
                            <div class="text-center overline font-weight-light">
                                No hay imágenes para mostrar
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-space-around mt-5">
                        <h3 class="font-weight-light d-flex justify-center">Anverso DNI</h3>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon 
                                    @click="openFileUpload('mdi-card-account-details-outline', 'dni_front', 'Adjuntar Anverso DNI', image.account ? image.account.id : null)" 
                                    color="green"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-image-plus-outline
                                </v-icon>
                            </template>
                            <span>Adjuntar Anverso DNI</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    :disabled="!image.dni_front" 
                                    @click="deleteImage(image.id, 'dni_front')" 
                                    color="red"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>Borrar</span>
                        </v-tooltip>
                    </div>
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column justify-center" flat>
                    <div class="d-flex justify-center" style="height: 250px">
                        <img v-if="image.dni_back" class="image" :src="image.dni_back" :width="$vuetify.breakpoint.smAndUp  ? 400 : '100%'">
                        <div v-else class="d-flex flex-column justify-center no-files">
                            <v-icon size="100"> mdi-image-search-outline </v-icon>
                            <div class="text-center overline font-weight-light">
                                No hay imágenes para mostrar
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-space-around mt-5">
                        <h3 class="font-weight-light d-flex justify-center">Reverso DNI</h3>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon 
                                    @click="openFileUpload('mdi-id-card', 'dni_back', 'Adjuntar Reverso DNI', image.account ? image.account.id : null)" 
                                    color="green"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-image-plus-outline
                                </v-icon>
                            </template>
                            <span>Adjuntar Reverso DNI</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    :disabled="!image.dni_back" 
                                    @click="deleteImage(image.id, 'dni_back')" 
                                    color="red"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>Borrar</span>
                        </v-tooltip>
                    </div>
                </v-col>
            </v-row>
        </div>

        <v-dialog v-model="isOpenFileUpload" width="800">
            <v-card class="" flat>
                <v-card-title class="primary--text">
                    <h2 class="font-weight-light">{{ title }}</h2>
                </v-card-title>
                <v-card-text class="my-n6 mb-n12">
                    <FileUpload 
                        action='storage/uploadUserImages'
                        allowedExtensions="['jpg', 'jpeg', 'png']"
                        :paramName="paramName"
                        :icon="icon"
                        :extra_params="image_extra_params"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        depressed
                        text
                        color="red"
                        @click="isOpenFileUpload = false"
                        class="mt-n4"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="isOpenCanvaSign" width="600">
            <v-card class="primary--text" flat>
                <v-card-title>
                    <h2 class="font-weight-light">Crear Firma</h2>
                </v-card-title>
                <v-card-text class="">
                    <CanvaComponent :render="isOpenCanvaSign"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        depressed
                        text
                        color="red"
                        @click="isOpenCanvaSign = false"
                        class="mt-n2"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import FileUpload from '@/components/RRHH/AccountsView/FormCuenta/FileUpload.vue';
import CanvaComponent from '@/components/Canva/CanvaComponent.vue';

export default {
    data: ()=> ({
        isOpenFileUpload: false,
        paramName: null,
        icon: null,
        title: null,
        image_extra_params: {},

        isOpenCanvaSign: false,
    }),
    components: {
        FileUpload,
        CanvaComponent,
    },
    computed: {
        images() {
            return this.userImages.length ? this.userImages : [{}];
        },
		...mapGetters('login', {
			hasAdminPermission: 'hasAdminPermission',
		}),
        ...mapState('storage', {
            userImages: state => state.userImages.images,
        }),
    },
    methods: {
        openFileUpload(icon, paramName, title, image_extra_params) {
            this.isOpenFileUpload = true;
            this.paramName = paramName;
            this.icon = icon;
            this.title = title;
            this.image_extra_params = {'account': image_extra_params};
        },
        deleteImage(id, field) {
            let upload = {
                id,
                field,
            }

            this.$store.dispatch('storage/deleteUserImagesPartial', upload);
        }
    },
    created() {
        // Force render the dialog component before it's opened
        this.isOpenCanvaSign = true;
        this.$nextTick(() => {
            this.isOpenCanvaSign = false;
        });
    },
}
</script>

<style scoped>
.image{
    border-radius: 15px;
    border: none;
    object-fit: contain;
    background-color: #e9e9e9;
}

.no-files{
    background-color: #e9e9e9;
    padding: 30px;
    border-radius: 15px;
}
</style>